const { registerBlockType } = wp.blocks;
const {InspectorControls, PanelColorSettings} = wp.blockEditor;
import { ResizableBox, PanelBody, RangeControl, ToggleControl, SelectControl, TextControl,  __experimentalBorderBoxControl as BorderBoxControl, __experimentalBoxControl as BoxControl, __experimentalNumberControl as NumberControl, __experimentalUnitControl as UnitControl, BaseControl, __experimentalInputControl as InputControl, TextareaControl } from '@wordpress/components';
const { Fragment } = wp.element;
const { __ } = wp.i18n;
import {colors} from './lib/colors';

const BlockEdit = (props) => {
	const { attributes, setAttributes, clientId } = props;
	const{ uniqueid, boxHeight, border, borderradius, margins, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bgColor, shadowColor, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, addclass, customcss}=attributes;
	setAttributes({ uniqueid: 'spiceblocksspacer' +clientId.slice(0,8) });
    const blockclass='spice-blocks-spacer';
	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

	function setBgColor(value) {
		setAttributes({bgColor:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
	const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
	const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
	const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;

	//console.log(border.width);
	return(
		<Fragment>
			<style dangerouslySetInnerHTML={{
			  __html: [
			     `#${uniqueid}{
						height: ${boxHeight}px;
						border: ${border.width} ${border.style} ${border.color};
						border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
						margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
						animation-delay: ${delay}ms;
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
						background-color:${bgColor};
					}
					${customcss}`					
			    ].join('\n')
			  }}>
			</style>
			<InspectorControls>
				<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
					<RangeControl 
			            label={__('Height(px)','spice-blocks')}
			           	value={boxHeight}
			           	units={[]}
			            onChange={(newtext) => setAttributes({ boxHeight: newtext })}
			            min={1}
						max={2000}
			           
			        />
			        <BorderBoxControl
			        	colors={colors}
			        	enableAlpha={'true'}
			            label={ __( 'Border' ,'spice-blocks') }
			            onChange={(newtext) => setAttributes({ border: newtext })}
			            value={ border }
			        />

			        <BaseControl className="spice-blocks-border-radius" label={__('Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
				        <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

				        <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} />			        
				        
				        <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

				        <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}/>	       
			        </BaseControl>

			        <BoxControl 
						label={__('Margin','spice-blocks')}
						inputProps={{ min: -300 }}
						values={margins}
						sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(newValue) =>
							setAttributes({
								...margins,
								margins: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>          			
			     
					<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>		
						<ToggleControl
							label={__('Enable/Disable on Desktop','spice-blocks')}
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Tablet','spice-blocks')}
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Mobile','spice-blocks')}
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
		        		<SelectControl
				            label={__('Animation','spice-blocks')}
				            value={ animation }
				            options={ [
				            	{ label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
			            	] }
		            		onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
		        		/>  
				        { animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>
			    </PanelBody>

			    <PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') }>	
					<RangeControl 
						label={ __('Horizontal Shadow(px)','spice-blocks') }			    
					    value={ hshadow}
					    onChange={(newtext) => setAttributes({ hshadow: newtext })}
						min={0}
						max={100}
					/>
					<RangeControl 
						label={ __('Vertical Shadow(px)','spice-blocks') }			    
					    value={ vshadow}
			        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
						min={0}
						max={100}
					/>	
					<RangeControl 
						label={ __('Blur Shadow(px)','spice-blocks') }			    
					    value={ blurshadow}
			        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
						min={0}
						max={100}
					/>
					<PanelColorSettings  initialOpen={true}
						className='spice-block-section-bg-color'
						title={ __('Box Shadow Color','spice-blocks') }
						colorSettings={[
							{
							value: shadowColor,
							enableAlpha:true,
							onChange: setShadowColor,
							label: __('Box Shadow','spice-blocks')
							},
						]}
					/>
				</PanelBody>

				<PanelBody initialOpen={false}	title={__('Background Settings','spice-blocks')}>
					<PanelColorSettings className={'spice-blocks-color-style'} 
						colorSettings={[
							{
								value: bgColor,
								enableAlpha:true,
								onChange: setBgColor,
								label: __('Background','spice-blocks')
							},
						]}
					/>
				</PanelBody>
				<PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                    <InputControl
                        label={__('Additional Class','spice-blocks')}
                        value={ addclass }
                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                    />
                    <TextareaControl
                        label={__('Custom CSS','spice-blocks')}
                        value={ customcss }
                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                    />
                </PanelBody>			    

			</InspectorControls>
			<div className={`${blockclass} ${animationclass} ${displayclass} ${addclass}`} id={uniqueid}>
				<ResizableBox
					className={'spice-blocks-spacer-wrapper'}
					size={{ height: boxHeight }}
					showHandle={props.isSslected}
					onResizeStop={(event, direction, resize_element, delta) => 
					props.setAttributes({ 
					boxHeight: parseInt(boxHeight + delta.height)
					})}
					enable={{
					top: false,
					left: false,
					right: false,
					topLeft: false,
					topRight: false,
					bottom: true,
					bottomLeft: false,
					bottomRight: false
					}}
				></ResizableBox>				
			</div>		
		</Fragment>
	);
};
 
registerBlockType('spice-blocks/spice-spacer', {
	title: __('Spacer','spice-blocks'),
	icon:<svg width="24.000000000000004" height="24.000000000000004" xmlns="http://www.w3.org/2000/svg"><g id="svg_15"><line stroke="#09A223" id="svg_13" y2="14.28773" x2="12.01978" y1="9.81011" x1="12.01978" fill="none"/><path stroke="#09A223" stroke-width="1" id="svg_3" d="m10.40726,10.04841l1.63237,-3.01457l1.63237,3.01457l-3.26473,0z" fill="#09A223"/><path stroke="#09A223" stroke-width="1" id="svg_4" d="m13.67202,14.03291l-1.63137,3.01517l-1.63336,-3.01397l3.26473,-0.0012z" fill="#09A223"/><g id="svg_14"><rect stroke="#09A223" stroke-width="1" id="svg_1" height="1.3867" width="23.82439" y="3.5758" x="0.12743" fill="#09A223"/><rect stroke="#09A223" stroke-width="1" id="svg_2" height="1.3867" width="23.82439" y="19.03749" x="0.12743" fill="#09A223"/></g></g></svg>,
	category:'spice-blocks',
	example: {
	    'attributes' : {
	        'mode' : 'preview',
	    }
	},
	keywords: ['Spice Spacer', 'Spacer'],
	attributes: {
		uniqueid:{
			type:'string',
		},
		boxHeight: {
			type: 'number',
			default:165
		},
		border: {
	        type: 'object',
	        default: {
	            color: '',
	            style: '',
	            width: '',        
	        },
	    },
	    bordertopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
	    borderbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    margins: {
	        default: {
	            top: '0px',
	            left: '0px',
	            right: '0px',
	            bottom: '0px'
	        }
		},
		hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
		hidedesktop:{
	    	type: 'boolean',
			default: true
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: true
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: true
	    },
		animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    },
	    bgColor:{
	    	type:'string',
	    },
	    shadowColor:{
	    	type:'string',
	    	default:'#000'
	    },
	    addclass:{
	    	type:'string',
	    },
	    customcss:{
	    	type:'string',
	    }
	},
	supports: {
		align: ['wide', 'full']
	},
	edit: BlockEdit,
	save: (props) => { 
		const { attributes } = props;
		const{uniqueid, boxHeight,border, borderradius, margins, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, bgColor, shadowColor, bordertopradius, borderrightradius, borderbottomradius, borderleftradius, addclass, customcss}=attributes;
		const blockclass='spice-blocks-spacer';
		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
		const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
		const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
		const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
 		
 		const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
		const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
		const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
		const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;

		return (
		<>
			<style dangerouslySetInnerHTML={{
			  __html: [
			     `#${uniqueid}{
						height: ${boxHeight}px;
						border: ${border.width} ${border.style} ${border.color};
						border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
						margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
						animation-delay: ${delay}ms;
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
						background-color:${bgColor};
					}
					${customcss}`					
			    ].join('\n')
			  }}>
			</style>
			<div id={uniqueid} className={`${blockclass} ${animationclass} ${displayclass} ${props.attributes.className} ${addclass}`} >
			</div>
		</>
		);
	}
});